import { render, staticRenderFns } from "./AddressDistrictSelection.vue?vue&type=template&id=0c79fe02&scoped=true&"
import script from "./AddressDistrictSelection.vue?vue&type=script&lang=js&"
export * from "./AddressDistrictSelection.vue?vue&type=script&lang=js&"
import style0 from "./AddressDistrictSelection.vue?vue&type=style&index=0&id=0c79fe02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c79fe02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VCombobox,VRow})
